import jsPDF from 'jspdf';
import 'jspdf-autotable'
import logo from '../../images/AOCLogo.png';
import { numberFormat } from '../../utils/numberFunctions'
import { dateFormat } from '../../utils/dateFunctions'
import { getAPIDataReturn } from '../../utils/apiFunction';
import { loadCompanyLabelLogo } from '../../utils/companyLogo';

const OTRPdf = async (data, printBin, printBag) => {
    const ifUndef = (field) => {
        return field ? field : '';
    }

    console.log(data)
    console.log('w')

    const { image: titleI, format: logoFormat } = await loadCompanyLabelLogo(logo,'labelLogo');

    var doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: [100, 150]
    });

    var smallerText = 10;
    var fontmedium = 12;
    var fontbig = 15;
    var fontbigger = 18;
    var fontbiggerText = 25;
    var fontbiggest = 35;
    var fontText = 7;
    var grades = await getAPIDataReturn('/Farms/Lookups/Grades');
    var stockItems = await getAPIDataReturn('/Transfers/StockItems/Get');
    var customers = await getAPIDataReturn('/Transfers/Customers');

    var noLabels = 0;
    if (data.coreTransferLines) {
        // Aggregate mixed groups: one label per group, showing total qty and breakdown
        const lines = data.coreTransferLines;
        const groups = new Map();
        lines.forEach(l => {
            const key = l?.mixedGroupId || l?.MixedGroupId || `__single_${l.id || Math.random()}`;
            if (!groups.has(key)) groups.set(key, []);
            groups.get(key).push(l);
        });
        const aggregated = [];
        groups.forEach((items, key) => {
            if (key.startsWith('__single_') || items.length === 1) {
                const it = items[0];
                aggregated.push({ ...it, __mixedGroupBreakdown: null });
            } else {
                const first = items[0] || {};
                const totalBins = items.reduce((p, c) => p + (Number(c.bins) || 0), 0);
                const totalBags = items.reduce((p, c) => p + (Number(c.bags) || 0), 0);
                const totalQty = items.reduce((p, c) => p + (Number(c.quantity) || 0), 0);
                    const breakdown = items.map((it) => ({
                        grade: stockItems.find(s => s.id === it?.stockItemId)?.grade?.description || 'Unknown',
                        qty: Number(it?.quantity) || 0,
                    }));
                aggregated.push({
                    ...first,
                    mixedGroupId: first?.mixedGroupId || first?.MixedGroupId || key,
                    bins: totalBins,
                    bags: totalBags,
                    quantity: totalQty,
                    __mixedGroupBreakdown: breakdown,
                });
            }
        });
        console.log(aggregated);
        for (var i = 0; i < aggregated.length; i++) {
            const lineItem = aggregated[i];
            if (lineItem.group) {
                // For mixed groups, create only ONE label regardless of bins/bags; else keep existing loops behavior
                var loops = (lineItem.__mixedGroupBreakdown ? 1 : ((printBin ? lineItem.bins : 0) + (printBag ? lineItem.bags : 0)));
                for (var j = 0; j < loops; j++) {
                    if (noLabels !== 0) {
                        doc.addPage();
                    }
                    noLabels++;
                    var isSeed = false;
                    if ((lineItem.stockItem.myobid === 'GROWOUT') || (lineItem.stockItem.myobid === 'SEEDSPAT')) {
                        isSeed = true;
                    }


                    var lineWidthTight = 5;
                    var lineWidth = 6
                    var max = 18;
                    var titleBarX = 10;
                    var line = 0;
                    var tempLine = line;
                    doc.addImage(titleI, logoFormat, 25, line, 50, 42);

                    line = 60;
                    doc.setFontSize(fontbig);
                    var compCode = data.prn ? data.prn : data.ivr;
                    var compCodeTag = data.prn ? 'PRN:' : 'IVR:';
                    doc.text(compCodeTag, 10, line);
                    //doc.setTextColor(0, 0, 0);
                    doc.setFontSize(fontbiggest);
                    doc.text(compCode, 25, line);
                    doc.setFontSize(smallerText);

                    line = line + 9;
                    doc.text('8 Sheridan Cl, Milperra NSW', 28, line);
                    line = line + 6;
                    doc.text('Lic: 51487', 41, line);
                    line = line + 9;
                    doc.setFontSize(fontmedium);
                    doc.text('To: ', 10, line);
                    doc.setFontSize(fontbigger);
                    var destinationName = '';
                    if (data.isCustomer && data.customerId && Array.isArray(customers)) {
                        const match = customers.find(c => c.id === data.customerId);
                        destinationName = match ? match.name : '';
                    }
                    if (!destinationName) {
                        destinationName = data.destination?.displayName;
                        if (destinationName === 'LIVEPRODCT') {
                            destinationName = 'AOC BATEMANS BAY';
                        } else if (destinationName === 'SYDNEY') {
                            destinationName = 'AOC KINGSGROVE';
                        }
                    }

                    doc.text(destinationName || '', 20, line);
                    doc.setDrawColor(0, 0, 0);
                    doc.rect(70, line + 1, 25, 18);
                    doc.setFontSize(fontbiggerText);

                    line = line + 8;
                    doc.setFontSize(fontmedium);
                    doc.text('Qty (' + (isSeed ? 'pcs' : 'doz') + '):', 75, line);
                    doc.setFontSize(fontbigger);
                    // For mixed group, show total quantity; else existing per-line quantity
                    const qtyForDisplay =  lineItem.group?.average;
                    doc.text(String(((qtyForDisplay) / (isSeed ? 1 : 12)).toFixed(0)), 73, line + 8);
                    doc.setFontSize(fontbigger);
                    doc.text(lineItem.stockItem?.species ? lineItem.stockItem?.species?.description : 'Sydney Rock', 10, line);
                    doc.setFontSize(fontbiggerText + 2);

                    line = line + 10;
                    // For mixed group, show breakdown line; else show single grade like before
                    if (lineItem.__mixedGroupBreakdown) {
                        doc.setFontSize(fontmedium);
                        const totalQty = lineItem.__mixedGroupBreakdown.reduce((s, p) => s + (p.qty || 0), 0) || 0;
                        const parts = lineItem.__mixedGroupBreakdown
                            .filter(p => (p.qty || 0) > 0)
                            .map(p => {
                                const pct = totalQty > 0 ? Math.round((p.qty / totalQty) * 100) : 0;
                                return `${p.grade} ${pct}%`;
                            });
                        // Wrap if long
                        const breakdownText = parts.join(' | ');
                        const split = doc.splitTextToSize(breakdownText, 80);
                        split.forEach((t, idx) => {
                            if (idx > 0) line += 6;
                            doc.text(t, 10, line);
                        });
                    } else {
                        var grade = lineItem.stockItem?.description.replace('Sydney Rock Single Seed', '').replace('Sydney Rock', '');
                        if ((grade === 'Oysters Grow-Out') || (grade === 'Seed Spat')) {
                            doc.setFontSize(fontmedium);
                            grade = grades.find((g) => { return g.id === lineItem?.group?.gradeId })?.description;
                        }
                        doc.text(grade, 10, line);
                    }
                    doc.setFontSize(fontbigger);
                    line = line + 8;
                    doc.text('Harvest Date: ' + dateFormat(data.harvestDate), 10, line);
                    line = line + 8;
                    doc.setFontSize(fontbigger - 3);
                    doc.text((data.source?.displayName?data.source?.displayName:data.source?.myobid), 10, line);
                    doc.setFontSize(smallerText);
                    doc.text(ifUndef(lineItem?.group?.previousLocation?.line?.lease?.harvestArea?.description), 65, line);
                    line = line + 7;
                    doc.text(ifUndef(lineItem?.group?.previousLocation?.line?.lease?.number), 65, line);
                    line = line + 7;
                    //doc.text('Export Approved', 65, line);
                    doc.setFontSize(fontbigger);
                    line = line + 10;
                    doc.text('Store Between 15 - 21C', 15, line);
                    //10 lines

                }
            }
        }
    }

    if (noLabels > 0) {
        const otrNumber = data.externalOTR || data.ExternalOTR || data.otr || data.OTR || '';
        doc.save('Labels For ' + otrNumber + '.pdf');
    }
}



function buildDesc(oy) {
    console.log(oy)
    if (oy.stockItem) {
        if (oy.stockItem.species && oy.stockItem.grade) {
            return (oy.stockItem.species.description + ' ' + oy.stockItem.grade.description)
        } else {
            return oy.stockItem.description;
        }
    } else {
        return 'Unknown';
    }

}

export default OTRPdf;